import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";
import { PageHero } from "@/components/PageHero";
import { Stagger, item } from "@/components/Reveal";

export default function Services() {
  const { content } = useLang();
  const { servicesPage } = content;
  return (
    <>
      <PageHero label={servicesPage.title} title={servicesPage.heading} intro={servicesPage.intro} image={IMAGES.servicesPage} />
      <section className="bg-white" data-testid="services-list-section">
        <Stagger className="divide-y divide-[var(--line)]" stagger={0.12}>
          {servicesPage.sections.map((s, i) => (
            <motion.div key={s.slug} variants={item}>
              <Link to={`/services/${s.slug}`} data-testid={`service-row-${s.slug}`} className="group block hover:bg-[var(--bg-grey)] transition-colors duration-500">
                <div className={`container-x grid grid-cols-12 gap-8 items-center ${i === 0 ? "pt-8 pb-14 md:pt-10 md:pb-20" : "py-14 md:py-20"}`}>
                  <div className="col-span-12 md:col-span-4">
                    <h2 className="font-head text-3xl md:text-4xl font-medium tracking-tight text-black">{s.title}</h2>
                    <span className="link-arrow mt-6 text-[13px]">{s.cta} <ArrowRight size={14} /></span>
                  </div>
                  <p className="col-span-12 md:col-span-5 text-sm md:text-base leading-relaxed text-[var(--ink-2)]">{s.text}</p>
                  <div className="col-span-12 md:col-span-3 img-frame aspect-[16/10]"><img src={IMAGES.services[s.slug]} alt={s.title} loading="lazy" /></div>
                </div>
              </Link>
            </motion.div>
          ))}
        </Stagger>
      </section>
    </>
  );
}
